import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  body {
    font-family: 'Sarabun', sans-serif;
  }
`;

export default GlobalStyles;
